import React from 'react';

function Header({ onLoginClick }) {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <span className="logo-icon">🏥</span>
          <div className="logo-text">
            <h1>Hope Nursing College</h1>
            <p>Excellence in Healthcare Education</p>
          </div>
        </div>
        <div className="header-right">
          <div className="header-contact">
            <span>📞 +1 (555) 123-4567</span>
            <span>📧 info@hopenu rsing.edu</span>
          </div>
          <button className="login-btn" onClick={onLoginClick}>
            🔐 Login
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;